import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { CmsData } from "@dotcom-frontend/data";
import {
  LgButtonComponent,
  LgGridColDirective,
  LgGridContainerDirective,
  LgGridRowDirective,
  LgIconComponent,
  LgInputDirective,
  LgInputFieldComponent,
  LgSuffixDirective
} from "@legal-and-general/canopy";

import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { WysiwygDirective } from "../../../directives/wysiwyg.directive";
import {
  loadResults,
  setSearchTerm
} from "../../../store/search/search.actions";
import { SearchState } from "../../../store/search/search.reducer";
import {
  selectSearchLoading,
  selectSelectedSearchFilters
} from "../../../store/search/search.selectors";
import { DynamicComponent } from "../../utils/dynamic-loader/dynamic.component";
import { SafeHtmlPipe } from "../../utils/pipes/safe-html..pipe";

@Component({
  selector: "dotcom-frontend-search",
  templateUrl: "./Search.component.html",
  styleUrl: "./Search.component.scss",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    LgGridRowDirective,
    LgGridContainerDirective,
    LgGridColDirective,
    LgInputDirective,
    LgButtonComponent,
    LgIconComponent,
    FormsModule,
    WysiwygDirective,
    SafeHtmlPipe,
    LgInputFieldComponent,
    LgSuffixDirective
  ]
})
export class SearchComponent implements DynamicComponent, OnInit {
  @Input() data: CmsData | undefined;
  showInNavigation: boolean | undefined;
  initialSearch = false;
  isBrowser = isPlatformBrowser(this.platformId);
  title: string | undefined;
  placeholder: string | undefined;
  searchTerm = "";
  collection = "";
  loading$: Observable<boolean> = this.store.select(selectSearchLoading);
  loading = false;
  page = 1;
  lgColMd = 8;
  lgColMdOffset = 2;
  lgColSm = 12;
  lgColSmOffset = 0;
  searchResultPage: string | undefined;
  selectedFilters$: Observable<number> = this.store.select(
    selectSelectedSearchFilters
  );
  selectedFilters: any;


  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    public store: Store<{ search: SearchState }>,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.loading$.subscribe((loading) => {
      this.loading = loading;
    });

    this.selectedFilters$.subscribe((filters) => {
      this.selectedFilters = filters;
    });
  }

  ngOnInit() {
    if (this.data) {
      this.title = this.data["searchTitle"];
      this.placeholder = this.data["searchPlaceholderText"];
      this.showInNavigation = this.data["showInNavigation"];
      this.initialSearch = this.data["initialSearch"];
    }

    if (this.showInNavigation === true) {
      this.lgColMd = 12;
      this.lgColMdOffset = 0;
      this.lgColSm = 12;
      this.lgColSmOffset = 0;
    }

    if (this.initialSearch) {
      this.route.queryParams.subscribe((params) => {
        this.searchTerm = params["q"];
        this.page = params["page"];
        this.collection = params["collection"];
        this.selectedFilters = {
          filterArticleYear: params["filterArticleYear"],
          filterCategory: params["filterCategory"],
          filterCategoryFolder: params["filterCategoryFolder"],
          filterCommunity: params["filterCommunity"],
          filterAuthor: params["filterAuthor"]
        };
      });

      this.store.dispatch(
        loadResults({
          query: this.searchTerm,
          collection: this.collection,
          page: this.page,
          filters: this.selectedFilters
        })
      );
    } else {
      this.store.pipe(select("search")).subscribe((storeData) => {
        this.collection = storeData["collectionName"];
        if (storeData["searchTerm"]) {
          this.searchTerm = storeData["searchTerm"];
        }
        this.page = storeData["page"];
        this.searchResultPage = storeData.searchResultPage;
      });
    }
  }

  search() {
    this.loading = true;
    if (!this.searchTerm.trim()) {
      this.loading = false;
      return;
    }

    this.store.dispatch(setSearchTerm({ searchTerm: this.searchTerm }));
    if (!this.initialSearch) {
      this.router.navigate([this.searchResultPage], {
        relativeTo: this.route,
        queryParams: {
          q: this.searchTerm,
          collection: this.collection,
          page: 1
        },
        onSameUrlNavigation: "reload"
      });
    } else {
      this.store.dispatch(
        loadResults({
          query: this.searchTerm,
          collection: this.collection,
          page: 1,
          filters: {}
        })
      );
    }
  }
}
